//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import stepTitle from "../StepTitle"
	import { api, config } from '@/service'
	import checkBox from '@/components/check-box'
	import radioBox from '@/components/radio-box'
	import Vue from 'vue'
	import umallSearch from "@/components/searchInput";

	export default {
		props: {
			// 带机上台的优惠及vas展示数
			daijiDiscVasCount: {
				type: Number,
				default: 0
			},
			// 是否为宽频的优惠及vas
			isBroadbandType: {
				type: Boolean,
				default: false
			},
			// 是否展示优惠
			showDis: {
				type: Boolean,
				default: false
			},
			// 是否展示VAS
			showVas: {
				type: Boolean,
				default: false
			},
			// 是否为宽频的优惠及vas
			isBroadbandType: {
				type: Boolean,
				default: false
			},
			currentVasDataLv1: {
				type: Object,
				default: null
			}, //vas列表 多選多列表
			currentDiscDataLv1List: {
				type: Array,
				default: null
			}, //优惠多选一 列表
			currentPackageLv1List: {
				type: Array,
				default: null
			}, //优惠多选多 列表
		},
		data() {
			// 判断是否选择了必选套餐
			let validatorVas = (rule, value, callback) => {
				let vasList = this.currentVasDataLv1
				if(vasList.vasRequired * 1 == 1) {
					//必须选择一个
					if(!this.form.freeVasInfoList.length) {
						callback(new Error('請選擇一個VAS增值服務'))
					} else {
						callback()
					}
				} else {
					callback()
				}
			}
			return {
				form: {
          freeVasInfoList: [], //選擇的vas列表
          discountInfoList: [], //選擇的優惠列表
        },
        rules: {
          vasCheck: [{
						required: true,
						validator: validatorVas,
						trigger: 'blur'
					}],
        }
			};
		},
		created() {
			
		},
		methods: {
			typeFn(index) {
        let _mediant = 0;
        if(this.isBroadbandType) {  // 宽频的优惠及vas需额外加2以及
          _mediant = this.daijiDiscVasCount + 2
        } 
				if(index == 2) { //优惠选择step
					return 2 + this.disIndex + _mediant
				} else if(index == 3) { //增值服务step
					return 2 + this.disIndex + this.vasIndex + _mediant
				}
			},
			//選擇優惠回調
			handlerMultiDiscountCheckBox(target, value, item) {
				let vasId = item.vasId
				let vasList = this.currentVasDataLv1.dataLv2List
				for(let i = 0; i < vasList.length; i++) {
					let vasObject = vasList[i]
					if(vasObject.id == vasId) {
            console.log('vasId', value, item, 126);
						Vue.set(vasObject, 'checked', value)
						if(value) {
							this.form.freeVasInfoList.push({
								id: vasObject.id,
								vasCode: vasObject.vasCode,
								vasName: vasObject.vasName
							})
						} else {
							let freeVasInfoList = this.form.freeVasInfoList
							freeVasInfoList.forEach(element => {
								if(item.id == element.id) {
									freeVasInfoList.pop(element)
								}
							})
						}
					}
				}
				if(target) {
					this.$refs.disFormMulti.clearValidate(target)
				}
			},
			//多選多回調
			handlerMultiMoreDiscountCheckBox(target, value, item, dataItem) {
				let vasId = item.vasId
				let vasList = this.currentVasDataLv1.dataLv2List
				//可選數量
				let selectableQuantity = dataItem.selectableQuantity * 1
				//判斷當前選擇數量是否等於可選數量
				let tempSelectIndex = 0
				dataItem.discountsList.forEach(element => {
					if(element.checked) {
						tempSelectIndex += 1
					}
				})
				let isEqual = selectableQuantity == tempSelectIndex - 1
				let removeElement = null
				if(isEqual && value) {
					//相等並且當前操作是選中一個優惠,去掉第一個選擇的item
					for(let i = 0; i < dataItem.discountsList.length; i++) {
						const element = dataItem.discountsList[i];
						if(element.checked && element.id != item.id) {
							element.checked = false
							removeElement = element
							break
						}
					}
				}
				for(let i = 0; i < vasList.length; i++) {
					let vasObject = vasList[i]
					if(vasObject.id == vasId) {
						Vue.set(vasObject, 'checked', value)
						if(value) {
							this.form.freeVasInfoList.push({
								id: vasObject.id,
								vasCode: vasObject.vasCode,
								vasName: vasObject.vasName
							})
						} else {
							let freeVasInfoList = this.form.freeVasInfoList
							freeVasInfoList.forEach(element => {
								if(item.vasId == element.id) {
									freeVasInfoList.pop(element)
								}
							})
						}
					}
					//移除超過選擇數量的優惠
					if(removeElement && removeElement.vasId == vasObject.id) {
						Vue.set(vasObject, 'checked', false)
						let freeVasInfoList = this.form.freeVasInfoList
						freeVasInfoList.forEach(element => {
							if(removeElement.vasId == element.id) {
								freeVasInfoList.pop(element)
							}
						})
					}
				}
				if(target) {
					this.$refs.disFormMulti.clearValidate(target)
				}
			},
			//单选回调
			handlerMultiRodioDiscountCheckBox(target, item, index, dataItem) {
				let vasId = item.vasId
				let vasList = this.currentVasDataLv1.dataLv2List
				dataItem.radioBoxSelectIndex = index
				//设置跟选择的类型绑定的vas
				let findVas = false
				for(let i = 0; i < vasList.length; i++) {
					let vasObject = vasList[i]
					if(vasObject.id == vasId) {
						//let value = vasObject.checked
						findVas = true
						Vue.set(vasObject, 'checked', true)
						this.form.freeVasInfoList.push({
							id: vasObject.id,
							vasCode: vasObject.vasCode,
							vasName: vasObject.vasName
						})
					}
				}
				if(!findVas) {
					let discountsList = dataItem.discountsList
					for(let i = 0; i < discountsList.length; i++) {
						let disItem = discountsList[i];
						for(let j = 0; j < vasList.length; j++) {
							let vasItem = vasList[j];
							if(disItem.vasId == vasItem.id) {
								vasItem.checked = false
								let freeVasInfoList = this.form.freeVasInfoList
								freeVasInfoList.forEach(freeItem => {
									if(freeItem.id == vasItem.id) {
										freeVasInfoList.pop(freeItem)
									}
								})
							}
						}
					}
				}
				this.$refs.disFormMulti.clearValidate(target)
			},
			//選擇vas列表回調
			handlerMultiVasCheckBox(value, item) {
        let vasId = item.id
        console.log(vasId, value, item, 251);
				if(value) {
					this.form.freeVasInfoList.push({
						id: item.id,
						vasCode: item.vasCode,
						vasName: item.vasName
					})
				} else {
					let freeVasInfoList = this.form.freeVasInfoList
					freeVasInfoList.forEach(element => {
						if(item.id == element.id) {
							freeVasInfoList.pop(element)
						}
					})
				}
				for(let i = 0; i < this.currentDiscDataLv1List.length; i++) {
					let discData = this.currentDiscDataLv1List[i]
					if(discData.vasId == vasId) {
						Vue.set(discData, 'checked', value)
					}
				}
				let discountsList = this.currentPackageLv1List
				for(let i = 0; i < discountsList.length; i++) {
					let discData = discountsList[i]
					let selectType = discData.selectType
					if(selectType == 'multiSelectOne') {
						for(let j = 0; j < discData.discountsList.length; j++) {
							let data = discData.discountsList[j]
							if(data.vasId == vasId) {
								if(value) {
									discData.radioBoxSelectIndex = j
								} else {
									discData.radioBoxSelectIndex = null
								}
							}
						}
					} else {
						for(let j = 0; j < discData.discountsList.length; j++) {
							let data = discData.discountsList[j]
							if(data.vasId == vasId) {
								Vue.set(data, 'checked', value)
							}
						}
					}
				}
				this.$refs['vasCheck'].clearValidate()
      },
			toPosition(dom, offsetValue = 100) {
				let {
					offsetTop
				} = dom
				window.scroll(0, offsetTop - offsetValue)
			},
			submitForm() {
				let _temp = true;
				//验证优惠是否选择
				if(this.showDis) {
					this.$refs['disFormMulti'].validate(async(valid, object) => {
						if(valid) {
							return _temp = true
						} else {
							let target = null;
							for(let i in object) {
								if(this.$refs[i]) {
									target = i
									break;
								}
							}
							let index = -1
							let find = target.indexOf('disFormMultiOneCheck')
							if(find != -1) {
								let tem = 'disFormMultiOneCheck'
								index = target.substring(tem.length, target.length) * 1
							}
							let findMore = target.indexOf('disFormMultiMoreCheck')
							if(findMore != -1) {
								let tem = 'disFormMultiMoreCheck'
								index = target.substring(tem.length, target.length) * 1
							}
							let dom = this.$refs[target][index].$el
							// console.log(this.$refs)
							this.toPosition(dom)
							return _temp = false
						}
					})
					if(!_temp) {
						return false
					}
				}
				if(this.showVas) {
					this.$refs['vasForm'].validate(async(valid, object) => {
						if(valid) return _temp = true
						else {
							let target = null;
							for(let i in object) {
								if(this.$refs[i]) {
									target = i
									break;
								}
							}
							let dom = this.$refs[target].$el
							this.toPosition(dom)
							return _temp = false
						}
					})
					if(!_temp) {
						return false
					}
				}
				return _temp
      },
      getForm() {
        //優惠信息接口入參拼接
        //优惠任選 列表
        let _temp = {};
				let discountsInfo = [];
				this.currentDiscDataLv1List.forEach(element => {
					if(element.checked || element.required == 1) {
            //已經選擇 或者 必選的時候，都要加入到優惠套餐選擇中
						// discountsInfo.push({ offerId: element.offerId })
            // 上台、宽频的优惠数据结构区分
            discountsInfo.push(this.isBroadbandType ? element : {offerId: element.offerId})
					}
				})
				//优惠多选多 列表
				this.currentPackageLv1List.forEach(element => {
					element.discountsList.forEach((zelement, index) => {
						if(element.selectType == 'multiSelectOne') {
							//多選一
							if(element.radioBoxSelectIndex == index) {
                // discountsInfo.push({ offerId: zelement.offerId })
                // 上台、宽频的优惠数据结构区分
                discountsInfo.push(this.isBroadbandType ? zelement : {offerId: zelement.offerId})
							}
						} else if(element.selectType == 'multiSelectMore') {
							if(zelement.checked || zelement.required == 1) {
								//已經選擇 或者 必選的時候，都要加入到優惠套餐選擇中
								// discountsInfo.push({ offerId: zelement.offerId })
                // 上台、宽频的优惠数据结构区分
                discountsInfo.push(this.isBroadbandType ? zelement : {offerId: zelement.offerId})
							}
						} else {
							//必選
							// discountsInfo.push({ offerId: zelement.offerId })
              // 上台、宽频的优惠数据结构区分
              discountsInfo.push(this.isBroadbandType ? zelement : {offerId: zelement.offerId})
						}
					})
        })
        // 上台、宽频的优惠及vas参数名
        let discountName = this.isBroadbandType ? 'discountList' : 'discountInfoList';
        let freeVasName = this.isBroadbandType ? 'vasList' : 'freeVasInfoList';
        _temp[discountName] = discountsInfo;
        _temp[freeVasName] = this.form.freeVasInfoList;
				//把必選的未選中的加入到接口參數中
				this.currentVasDataLv1.dataLv2List.forEach(element => {
					if(element.required * 1 == 1) {
						let isFind = false
						//vas為必選時，判斷是否有加入到接口上傳參數中
						_temp[freeVasName].forEach(felement => {
							if(felement.id == element.id) {
								isFind = true
							}
						})
						if(!isFind) {
							_temp[freeVasName].push({
								id: element.id,
								vasCode: element.vasCode,
								vasName: element.vasName
							})
						}
					}
        })
        console.log(_temp, 437);
        return _temp;
      }
		},
		computed: {
			disIndex() {
				//显示优惠信息的step title index
				if(this.showDis) {
					return 1
				}
				return 0
			},
			vasIndex() {
				//显示vas信息的step title index
				if(this.showVas) {
					return 1
				}
				return 0
			},
			currentDiscDataLv1ListMustSelect() {
				let list = this.currentDiscDataLv1List
				//需求，所有都是必选的时候，隐藏标题
				let mustSelect = true
				list.forEach(element => {
					//required == 1 为必选  == 2 可选
					if(element.required * 1 == 2 || element.required * 1 == 3) {
						mustSelect = false
					}
				})
				return mustSelect
			},
			disRules() {
				let currentPackageLv1List = this.currentPackageLv1List
				let rules = {}
				//验证是否选择了优惠必选多选多
				let validatorDisMore = (rule, value, callback) => {
					let disItem = this.currentPackageLv1List
					disItem.forEach(element => {
						if(element.selectType == 'multiSelectMore') {
							//多选多
							let selectableQuantity = element.selectableQuantity * 1
							let selectIndex = 0
							element.discountsList.forEach(element => {
								if(element.checked) {
									selectIndex += 1
								}
							})
							if(selectIndex == selectableQuantity) {
								callback()
							} else {
								if(selectIndex > 0) {
									callback(new Error('請選擇優惠'))
								}
							}
							return
						}
					})
					callback()
				}

				let validatorDisOne = (rule, value, callback) => {
					let disItem = this.currentPackageLv1List
					disItem.forEach((element, index) => {
						if(element.selectType == 'multiSelectOne') {
							if(typeof element.radioBoxSelectIndex == 'undefined') {
								//沒選擇的時候不用判斷
								callback()
								return
							}
							//多选一
							if(element.radioBoxSelectIndex * 1 < 0) {
								callback(new Error('請選擇優惠'))
							} else {
								callback()
							}
							return
						}
					})
					callback()
				}
				currentPackageLv1List.forEach((element, index) => {
					if(element.selectType == 'multiSelectOne') {
						let key = 'disFormMultiOneCheck' + index
						rules[key] = {
							required: true,
							validator: validatorDisOne,
							trigger: 'blur'
						}
					} else if(element.selectType == 'multiSelectMore') {
						let key = 'disFormMultiMoreCheck' + index
						rules[key] = {
							required: true,
							validator: validatorDisMore,
							trigger: 'blur'
						}
					}
				})
				return rules
			}
		},
		components: {
			stepTitle,
			checkBox,
			radioBox
		}
	};
